import { ComponentInterface, getElement } from "@stencil/core";
import * as Sentry from "@sentry/react";
import { BRAND_NAME, UIKIT_VERSION } from "../constants/global-constants";

export function InitLogging() {
  return (proto: ComponentInterface, field: any) => {
    const { componentWillLoad, componentDidLoad } = proto;

    // Establishing transaction for component logging on componentWillLoad()
    proto.componentWillLoad = function () {
      const host = getElement(this);
      this[field] = initLogging(host);
      return componentWillLoad && componentWillLoad.call(this);
    };

    // Closing transaction when component is loaded on componentDidLoad()
    proto.componentDidLoad = function () {
      if (this[field]) this[field].finish();
      return componentDidLoad && componentDidLoad.call(this);
    };
  };
}

function initLogging(component: any) {
  const tag = component.tagName.toLowerCase();

  const transaction = Sentry.startTransaction({
    name: tag,
    sampled: true,
    tags: {
      "uikit.component": tag,
      "uikit.version": UIKIT_VERSION,
      "uikit.brand": BRAND_NAME,
      "uikit.domain": window.location.host,
      "uikit.test": "true"
    }
  });

  return transaction;
}
